const { PanelRow, SelectControl, Spinner } = wp.components;
const { useEffect, useState } = wp.element;
const { applyFilters } = wp.hooks;
const { __ } = wp.i18n;

export function SelectCptTaxonomy(props) {
	const { setAttributes, block_post_type, block_taxonomy } = props;
	const [types, setTypes] = useState([]);
	const [taxonomies, setTaxonomies] = useState([]);
	const [loading, setLoading] = useState(true);
	const [help, setHelp] = useState('');
	const [error, setError] = useState('');

	useEffect(() => {
		const fetchCPTs = applyFilters('fetch-sitemap-cpts', null);
		if (typeof fetchCPTs !== 'function') {
			return;
		}

		let active = true;
		fetchCPTs(props).then((postTypes) => {
			if (active) {
				setTypes(Array.isArray(postTypes) ? postTypes : []);
			}
		});

		return () => {
			active = false;
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		let active = true;
		setLoading(true);
		setError('');

		wp.apiFetch({
			path: `/wp/v2/taxonomies?type=${encodeURIComponent(
				block_post_type
			)}&context=edit`,
			method: 'GET',
		}).then(
			(data) => {
				if (!active) {
					return;
				}

				const options = Object.values(data || {})
					.filter(({ slug }) => slug !== 'post_format')
					.map(({ slug, name }) => ({ value: slug, label: name }));

				setTaxonomies(options);
				setLoading(false);

				if (options.length === 0) {
					setHelp(
						__(
							'No taxonomies found for this post type.',
							'simple-sitemap'
						)
					);
					setAttributes({ block_taxonomy: '' });
					return;
				}

				setHelp('');
				if (!options.some(({ value }) => value === block_taxonomy)) {
					setAttributes({ block_taxonomy: options[0].value });
				}
			},
			() => {
				if (!active) {
					return;
				}

				setTaxonomies([]);
				setLoading(false);
				setError(
					__(
						'Unable to load taxonomies. Please try again.',
						'simple-sitemap'
					)
				);
				setAttributes({ block_taxonomy: '' });
			}
		);

		return () => {
			active = false;
		};
	}, [block_post_type]); // eslint-disable-line react-hooks/exhaustive-deps

	const updatePostTypeValues = (value) => {
		setAttributes({ block_post_type: value });
	};
	const state = {
		types,
		taxonomies,
		taxonomy_select_disabled_status: loading || taxonomies.length === 0,
		taxonomy_select_disabled_help: error || help,
		wrapperClass: error || taxonomies.length === 0 ? 'disabled' : '',
	};
	const postTypeSelect = applyFilters(
		'sitemap-group-post-types-select',
		'',
		props,
		state,
		updatePostTypeValues
	);
	const moreTaxonomies = applyFilters(
		'sitemap-list-more-taxonomies',
		<PanelRow>
			<p className="simple-sitemap-upgrade-hint">
				{__('List', 'simple-sitemap')}{' '}
				<a
					href="https://wpgoplugins.com/plugins/simple-sitemap-pro/#taxonomies-for-any-post-type"
					target="_blank"
					rel="noreferrer"
				>
					{__('taxonomies', 'simple-sitemap')}
				</a>{' '}
				{__('for any post type', 'simple-sitemap')}
			</p>
		</PanelRow>
	);

	return (
		<div className={`ss-taxonomy-select ${state.wrapperClass}`}>
			{postTypeSelect}
			{loading ? (
				<Spinner />
			) : (
				<SelectControl
					label={__('Select taxonomy', 'simple-sitemap')}
					value={block_taxonomy}
					options={taxonomies}
					onChange={(value) =>
						setAttributes({ block_taxonomy: value })
					}
					disabled={state.taxonomy_select_disabled_status}
					help={state.taxonomy_select_disabled_help}
				/>
			)}
			{moreTaxonomies}
		</div>
	);
}
